import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckSmallGreen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M6.66647 10.6139L12.7947 4.48566L13.7375 5.42846L6.66647 12.4995L2.42383 8.25691L3.36664 7.31411L6.66647 10.6139Z",
			fill: "#17B26A"
		})
	})
});
export default SvgCheckSmallGreen;
